import API from "../utils/api.js"; // <-- IMPORTANT: this points to api.js

// -------------------- Conversations --------------------

export const getConversations = (params = {}) =>
  API.get("conversations/", { params });

export const getConversation = (id) =>
  API.get(`conversations/${id}/`);

export const createConversation = (data) =>
  API.post("conversations/", data);

export const getOrCreateConversation = (leadId) =>
  API.post("conversations/get_or_create/", { lead: leadId });

export const transferConversation = (id, userId) =>
  API.post(`conversations/${id}/transfer/`, {
    assigned_to: userId,
  });

export const deleteConversation = (id) =>
  API.delete(`conversations/${id}/`);

export const updateConversation = (id, data) =>
  API.patch(`conversations/${id}/`, data);

// -------------------- Messages --------------------

export const getConversationMessages = (id) =>
  API.get(`conversations/${id}/messages/`);

export const sendConversationMessage = (id, body) =>
  API.post(`conversations/${id}/messages/`, { body });
